'use client';

import { useState, useEffect } from 'react';
import sanitizeHtml from 'sanitize-html';

interface HtmlRendererProps {
  html: string;
  fgColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

// used to render html specifically from the folder.description field
// without causing any hydration errors
export default function HtmlRenderer({ html, className, style }: HtmlRendererProps) {
  const [mounted, setMounted] = useState(false);
  // eslint-disable-next-line
  useEffect(() => setMounted(true), []);
  if (!mounted) {
    return null;
  }

  // closes unclosed tags and condenses html given
  const cleanHtml = sanitizeHtml(html, {
    // TODO: should we scrub certain tags and attributes here as well??
    allowedTags: false,
    allowedAttributes: false,
    allowVulnerableTags: true
  });

  return (
    <div className={className} style={style} dangerouslySetInnerHTML={{ __html: cleanHtml }} />
  );
}
